module.exports = __webpack_public_path__ + "static/media/national-cancer-institute-701-FJcjLAQ-unsplash.bc8f7782.jpg";